import { UserCharactersService } from "./UserCharactersService";
import { UserLooksService } from "./UserLooksService";
import { UserService } from "./UserService";

/**
 * Global services manager that provides access to services from both React and Phaser code
 */
class ServicesManager {
  private static instance: ServicesManager | null = null;

  private _userCharactersService: UserCharactersService | null = null;
  private _userLooksService: UserLooksService | null = null;
  private _userService: UserService | null = null;

  private constructor() {}

  static getInstance(): ServicesManager {
    if (!ServicesManager.instance) {
      ServicesManager.instance = new ServicesManager();
    }
    return ServicesManager.instance;
  }

  // Setters for React to initialize services
  setUserCharactersService(service: UserCharactersService): void {
    this._userCharactersService = service;
  }

  setUserLooksService(service: UserLooksService): void {
    this._userLooksService = service;
  }

  setUserService(service: UserService): void {
    this._userService = service;
  }

  // Getters for both React and Phaser code
  get UserCharactersService(): UserCharactersService | null {
    return this._userCharactersService;
  }

  get UserLooksService(): UserLooksService | null {
    return this._userLooksService;
  }

  get UserService(): UserService | null {
    return this._userService;
  }

  // Check if all services are initialized
  get isInitialized(): boolean {
    return !!(
      this._userCharactersService &&
      this._userLooksService &&
      this._userService
    );
  }

  // Clear all services (useful for cleanup)
  clear(): void {
    this._userCharactersService = null;
    this._userLooksService = null;
    this._userService = null;
  }
}

export default ServicesManager;
